import { v4 } from "uuid";
/**
 * @deprecated
 */
export const createKey = () => v4();
